import './Register.css';
import { FcGoogle } from 'react-icons/fc';
import { TiCancel } from 'react-icons/ti';
import { Link, useNavigate } from 'react-router-dom';
import useForm from './useForm';
import { signupForm } from './utility/formConfig';
import { useEffect, useState } from 'react';
import { axiosInstance } from '../../../config.util';

export default function Register(){
    const { renderFormInputs, isFormValid } = useForm(signupForm);
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [serverMsg, setServerMsg] = useState({
        usrnameErrorMsg: '', 
        emilErrorMsg: '' ,
        successSignup: '',
        unIdentifiedErr: ''
    })
    const navigate = useNavigate();

    useEffect(()=>{
        // let arrOfInp = [...document.getElementsByClassName('signup-input')]
        // // console.log(arrOfInp);
        // for (let i = 0; i < arrOfInp.length; i++) {
        //     // console.log(arrOfInp[i].value);
        //     if(arrOfInp[i].computedName === 'username'){
        //         // console.log('got the value', arrOfInp[i].value);
        //         // console.log('got computedValue', arrOfInp[i].computedName);
        //         setUsername(arrOfInp[i].value)
        //     }
        //     else if(arrOfInp[i].computedName === 'email'){
        //         // console.log('got the value', arrOfInp[i].value);
        //         // console.log('got computedValue', arrOfInp[i].computedName);
        //         setEmail(arrOfInp[i].value)
        //     }
        //     else if(arrOfInp[i].computedName === 'password'){
        //         // console.log('got the value', arrOfInp[i].value);
        //         // console.log('got computedValue', arrOfInp[i].computedName);
        //         setPassword(arrOfInp[i].value)
        //     }
        // }
        const data = document.querySelectorAll('.signup-input')
        data.forEach(input=>{
            if(input.name === 'name')setUsername(input.value);
            if(input.name === 'email')setEmail(input.value);
            if(input.name === 'password')setPassword(input.value);
        })
    })

    const textColor = ['#f9b167', '#f9d342', '#df678c', '#aabac7', 'white'];
    const randomTColor = textColor[Math.floor(Math.random() * textColor.length)];

    const bGColor = ['#FCE77D', '#292826', '#3D155F', '#4831D4', '#282e36', 'black'];
    const randomBgColor = bGColor[Math.floor(Math.random() * bGColor.length)];

    function initializeAvatar(text, fColor = "white", bgColor = "#21272f") {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        ctx.save();
        canvas.width = 200;
        canvas.height = 200;

        ctx.fillStyle = randomBgColor || fColor; //bg
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        
        ctx.textAlign = "center";
        ctx.font = "bold 100px arial";
        ctx.fillStyle = randomTColor || bgColor; //text
        ctx.textBaseline = "middle";
        ctx.fillText(text, canvas.width / 2, canvas.height / 2);
        ctx.restore();

        return canvas.toDataURL('image/png');
    }

    const formSubmit = (e)=>{
        e.preventDefault()
        // console.log(username, email, password);
        const user = {
            username: username,
            email: email,
            password: password,
            avatar: initializeAvatar(username[0].toUpperCase(),randomBgColor, randomTColor)
        }
        // console.log(user.username);
        registerApiCall(user)
    }

    const registerApiCall = async (user)=>{
        try {
            await axiosInstance.post('/auth/register', user, {
                headers: {
                    // 'Content-Type': 'application/x-www-form-urlencoded',
                    'Content-Type': 'application/json',
                    "Access-Control-Allow-Origin":"https://ndevhub.vercel.app"
                    // "Access-Control-Allow-Origin":"http://localhost:3000"
                }
            }).then((res=>{
                setServerMsg({
                    successSignup: 'Welcome, success signup'
                });
                navigate('/login');
            })).catch(error=>{
                if(error.response.data.hasOwnProperty('username')){
                    setServerMsg({
                        usrnameErrorMsg: error.response.data.username
                    })
                }
                else if(error.response.data.hasOwnProperty('email')){
                    setServerMsg({
                        emilErrorMsg: error.response.data.email
                    })
                }else{
                    setServerMsg({
                        unIdentifiedErr: 'Something Went Wrong try again working realy hard'
                    })
                }
            });
        } catch (error) {
            setServerMsg({
                unIdentifiedErr: 'Something Went Wrong try again working realy hard'
            })
        }
    }
    
    return(
        <div className="signup__container">
            <div className="signup__wrapper">
                <div className="signup__details-left">
                    <div className="signup_box">
                        <div className="lb-nested">
                            <div className="signup-desc">
                                <span className='whatisIt'>Productivity <br />Network</span>
                                <hr className='spacer'/>
                                <span className='wr'>We are</span>
                                <h2 className='appname'>next gen DEVHUB</h2>
                                <p className='app-desc'>Oath to build a better <span>developer</span> community.</p>
                                <p className='app-desc-para'>We invite all dev student & tech lover</p>
                                <p>
                                <a style={{fontSize: '1.3rem'}} href="https://ullaskunder.tech/" title="ullaskunder.tech"> ullaskunder.tech </a>
                                </p>
                                <h4>Lets build & learn together</h4>
                            </div>
                            <div className="signup-linkto">
                                <span>Already have an account?</span>
                                <Link to="/login">
                                    <span className='linkto-signup'>Log in</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="signup__details-right">
                    {serverMsg.unIdentifiedErr ? <span className='su__server__message'> {serverMsg.unIdentifiedErr} </span>:null} 
                    {serverMsg.usrnameErrorMsg ? <span className='su__server__message'> {serverMsg.usrnameErrorMsg} </span>:null}
                    {serverMsg.emilErrorMsg ? <span className='su__server__message'> {serverMsg.emilErrorMsg} </span>:null}
                    {serverMsg.successSignup ? <span className='su__server__message--success'> {serverMsg.successSignup} </span>:null}
                    <div className='signin__heading' style={{fontSize: "2.9rem", fontWeight: "bold"}}>Wlcome to DevHub
                    <p>
                    <p style={{fontSize: "1.5rem", fontWeight: "500", marginRight: "1rem", marginTop:'1rem', display: 'inline-block'}}>Already have an account?</p>
                        <Link to="/login">
                            <span style={{fontSize: "1.5rem", fontWeight: "500"}} className='linkto-signup'>LogIn</span>
                        </Link>
                    </p>
                    </div>
                    <form className="signup__main" onSubmit={formSubmit}>
                        {renderFormInputs()}
                        <button className={`btn signup__btn-main ${!isFormValid()?'ds_btn':"alw_btn"}`} type='submit' disabled={!isFormValid()}>{!isFormValid() ? <TiCancel />:'Create account'}</button>
                    </form>
                    <div className="signup-or-from">
                        <div className="title_lines">OR</div>
                    </div>
                    <div className="signup-or-from">
                        <button type="submit" className='btn signup__google'>
                            <FcGoogle className='signup-btn__icon' />
                            X - with Google - x
                        </button>
                    </div>
                </div>
                <p style={{position: 'absolute', bottom: '10px', fontSize: '1.5rem', right: '30px' }}>connect <a href="ullaskunder.tech" title='ullaskunder contact frontend portfolio' style={{ fontWeight: 700 }}>@ullaskunder </a></p>
            </div>
        </div>
    )
}